<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="form-base__title step-name">Сведения о заявителе</div>

        <Subject
          :statement="statement"
          :subject="statement.subjects.applicant"
        />
      </v-col>
    </v-row>

    <v-row v-if="statement.securingEvidenceStep2">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Прошу обеспечить доказательства в виде осмотра информации, находящейся
          в информационно-телекоммуникационной сети "Интернет"
        </div>

        <Step2 :data="statement.securingEvidenceStep2" />
      </v-col>
    </v-row>

    <v-row v-if="statement.securingEvidenceStep3">
      <v-col cols="12">
        <div class="form-base__title step-name">
          В соответствии со статьей 103 Основ законодательства Российской
          Федерации о нотариате от 11.02.1993 № 4462-1 прошу
        </div>

        <Step3 :data="statement.securingEvidenceStep3" />
      </v-col>
    </v-row>

    <v-row v-if="statement.securingEvidenceStep4">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Реквизиты счета для возврата заявителю суммы платежа за совершение
          нотариального действия в случае отказа в совершении нотариального
          действия
        </div>

        <StepRequisites
          :data="statement.securingEvidenceStep4"
          :statement-type="StatementType.SECURING_EVIDENCE"
        />
      </v-col>
    </v-row>

    <v-row v-if="statement.locationStep">
      <v-col cols="12">
        <div class="form-base__title step-name">
          Выбор места совершения нотариального действия
        </div>

        <StepSign :data="statement.locationStep" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Subject from '@/components/elements/statement/FullStatementView/elements/Subject';
import Step2 from '@/components/elements/statement/FullStatementView/steps/SecuringEvidence/Step2';
import Step3 from '@/components/elements/statement/FullStatementView/steps/SecuringEvidence/Step3';
import StepRequisites from '@/components/elements/statement/FullStatementView/steps/common/StepRequisites';
import StepSign from '@/components/elements/statement/FullStatementView/steps/common/StepSign';
import { StatementType } from '@/types/services';

export default {
  name: 'SecuringEvidence',
  components: {
    Subject,
    Step2,
    Step3,
    StepRequisites,
    StepSign,
  },
  props: {
    statement: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    StatementType,
  }),
};
</script>
